import React from 'react';
import ReactDOM from 'react-dom';
import Message from '../template/Message';

function showMessage(text, variant,time = 10000) {
    const element = (
        <Message open={true} text={text} variant={variant} handleClose={closeMessage} />
    );
    setTimeout(() => ReactDOM.render(element, document.getElementById('meuinss-message')));
    var to = setTimeout(() => {closeMessage()}, time);

    function closeMessage(event, reason) {
        if(reason !== "clickaway") {
            clearTimeout(to);
            ReactDOM.render(null, document.getElementById('meuinss-message'));
        }
    }
}

export function showError(text) {
    showMessage(text, 'error');
}

export function showSuccess(text) {
    showMessage(text, 'success');
}

export function showSuccessTime(text, time) {
    showMessage(text, 'success', time);
}

export function showErrorTime(text, time) {
    showMessage(text, 'error', time);
}